import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route change (with graceful fallback).
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in document.documentElement ? "instant" : "auto" });
  }, [pathname]);
  return null;
}
